import { t } from "@lingui/macro";
import { FingerprintIcon, GithubLogoIcon } from "@phosphor-icons/react";
import { motion } from "framer-motion";

import { useAuthProviders } from "@/client/services/auth/providers";

const ease = [0.22, 1, 0.36, 1] as const;

export const SocialAuth = () => {
  const { providers } = useAuthProviders();

  if (!providers) return null;

  const hasSocial =
    providers.includes("google") || providers.includes("github") || providers.includes("openid");

  if (!hasSocial) return null;

  return (
    <div className="mb-5 flex flex-col gap-3">
      <p className="text-center text-[0.78rem] text-gray-400">{t`S'inscrire avec`}</p>

      {/* Google */}
      {providers.includes("google") && (
        <motion.a
          href="/api/auth/google"
          whileHover={{ scale: 1.015, boxShadow: "0 4px 16px rgba(0,0,0,0.08)" }}
          whileTap={{ scale: 0.985 }}
          transition={{ duration: 0.2, ease }}
          className="flex h-[50px] w-full items-center justify-center gap-3 rounded-2xl border border-gray-200 bg-white text-[0.9rem] font-semibold text-gray-700 shadow-sm transition-colors hover:bg-gray-50/80"
        >
          {/* Official Google G logo */}
          <svg className="h-5 w-5 shrink-0" viewBox="0 0 48 48" aria-hidden="true">
            <path
              fill="#EA4335"
              d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
            />
            <path
              fill="#4285F4"
              d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
            />
            <path
              fill="#FBBC05"
              d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
            />
            <path
              fill="#34A853"
              d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
            />
          </svg>
          {t`Continuer avec Google`}
        </motion.a>
      )}

      {/* GitHub */}
      {providers.includes("github") && (
        <motion.a
          href="/api/auth/github"
          whileHover={{ scale: 1.015 }}
          whileTap={{ scale: 0.985 }}
          transition={{ duration: 0.2, ease }}
          className="flex h-[50px] w-full items-center justify-center gap-3 rounded-2xl bg-[#1a1a1a] text-[0.9rem] font-semibold text-white shadow-sm transition-colors hover:bg-[#2a2a2a]"
        >
          <GithubLogoIcon className="h-5 w-5 shrink-0" />
          {t`Continuer avec GitHub`}
        </motion.a>
      )}

      {/* OpenID */}
      {providers.includes("openid") && (
        <motion.a
          href="/api/auth/openid"
          whileHover={{ scale: 1.015 }}
          whileTap={{ scale: 0.985 }}
          transition={{ duration: 0.2, ease }}
          className="flex h-[50px] w-full items-center justify-center gap-3 rounded-2xl bg-[#dc2626] text-[0.9rem] font-semibold text-white shadow-sm transition-colors hover:bg-[#b91c1c]"
        >
          <FingerprintIcon className="h-5 w-5 shrink-0" />
          {import.meta.env.VITE_OPENID_NAME}
        </motion.a>
      )}
    </div>
  );
};
